var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _g, _path32, _g2, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _g3, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDevelopment(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 680,
    height: 680,
    viewBox: "0 0 680 680",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 100,
    width: 580,
    height: 530,
    fill: "#1A1A1A"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    y: 100,
    width: 530,
    height: 580,
    fill: "#1A1A1A"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 630,
    y: 580,
    width: 50,
    height: 50,
    fill: "var(--color-primary)"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 630,
    y: 630,
    width: 50,
    height: 50,
    fill: "url(#paint0_linear_1_1785)"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 580,
    y: 630,
    width: 50,
    height: 50,
    fill: "var(--color-ternary)"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    width: 580,
    height: 580,
    transform: "translate(50 50)",
    fill: "#222222"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M574.344 333.413C574.517 334.631 574.688 335.847 574.858 337.065C579.46 370.178 582.773 403.937 577.44 436.941C572.106 469.944 557.231 502.5 531.026 523.258C491.622 554.471 431.269 557.568 383.236 558.087C332.227 558.638 281.218 559.189 230.21 559.74C209.392 559.965 188.374 560.172 168.007 555.851C145.225 551.018 117.697 538.5 107.216 516.375C96.5822 493.926 98.3048 466.784 106.743 443.948C116.658 417.114 135.123 394.395 154.135 373.021C173.148 351.647 193.226 330.803 207.398 305.953C227.667 270.415 234.95 228.226 257.903 194.36C272.703 172.522 293.519 155.116 316.67 142.471C362.309 117.543 419.928 111.541 466.546 134.587C502.308 152.266 528.824 185.22 545.367 221.522C561.398 256.704 568.897 295.107 574.344 333.413Z",
    fill: "#212121"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M158.251 176.507C152.578 185.176 147.47 194.278 145.01 204.298C140.465 222.803 147.996 239.616 163.108 250.608C174.125 258.623 189.871 259.515 201.722 252.795C208.277 249.079 213.467 243.412 218.52 237.822C237.499 216.827 257.379 192.371 255.722 164.119C253.926 133.484 226.546 120.199 199.445 133.704C183.259 141.77 171.705 156.697 161.514 171.636C160.415 173.248 159.323 174.869 158.251 176.507Z",
    fill: "#1E1E1E"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M317.63 487.016H239.836C239.139 487.016 238.575 486.451 238.575 485.754V475.639C238.575 474.941 239.14 474.377 239.836 474.377H317.63C318.327 474.377 318.891 474.942 318.891 475.639V485.754C318.891 486.452 318.327 487.016 317.63 487.016Z",
    fill: "var(--color-ternary)",
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M319.046 480.482H238.419V528.373H319.046V480.482Z",
    fill: "var(--color-primary)",
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M255.497 487.617H301.19",
    stroke: "#212121",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M255.497 494.353H301.19",
    stroke: "#212121",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M255.497 501.089H301.19",
    stroke: "#212121",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M255.497 507.826H301.19",
    stroke: "#212121",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M245.978 484.761L250.084 487.654L245.978 490.64",
    stroke: "#212121",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M302.232 510.253H224.438C223.741 510.253 223.177 509.687 223.177 508.991V498.876C223.177 498.179 223.742 497.615 224.438 497.615H302.232C302.929 497.615 303.493 498.18 303.493 498.876V508.991C303.494 509.687 302.929 510.253 302.232 510.253Z",
    fill: "var(--color-ternary)",
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M303.648 503.719H223.021V551.609H303.648V503.719Z",
    fill: "black"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M240.099 510.853H285.792",
    stroke: "var(--color-ternary)",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M240.099 517.589H285.792",
    stroke: "var(--color-ternary)",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M240.099 524.326H285.792",
    stroke: "var(--color-ternary)",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M240.099 531.062H285.792",
    stroke: "var(--color-ternary)",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M230.581 507.998L234.686 510.891L230.581 513.876",
    stroke: "var(--color-ternary)",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M495.697 489.932L485.618 497.211L495.138 503.37",
    stroke: "var(--color-primary)",
    strokeMiterlimit: 10
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M576.324 493.851C576.324 494.469 575.822 494.971 575.204 494.971C574.586 494.971 574.084 494.469 574.084 493.851C574.084 493.233 574.586 492.731 575.204 492.731C575.822 492.731 576.324 493.233 576.324 493.851Z",
    stroke: "var(--color-primary)",
    strokeMiterlimit: 10
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M575.204 500.57C575.823 500.57 576.324 500.069 576.324 499.45C576.324 498.832 575.823 498.331 575.204 498.331C574.586 498.331 574.084 498.832 574.084 499.45C574.084 500.069 574.586 500.57 575.204 500.57Z",
    stroke: "var(--color-primary)",
    strokeMiterlimit: 10
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M545.528 496.651C545.528 500.671 543.272 503.929 540.489 503.929C537.706 503.929 535.45 500.67 535.45 496.651C535.45 492.631 537.706 489.372 540.489 489.372C543.272 489.372 545.528 492.631 545.528 496.651Z",
    stroke: "var(--color-primary)",
    strokeMiterlimit: 10
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M506.896 496.651H515.854",
    stroke: "var(--color-primary)",
    strokeMiterlimit: 10
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M520.893 496.651H529.851",
    stroke: "var(--color-primary)",
    strokeMiterlimit: 10
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M553.647 494.17H565.965",
    stroke: "var(--color-primary)",
    strokeMiterlimit: 10
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M553.647 499.132H565.965",
    stroke: "var(--color-primary)",
    strokeMiterlimit: 10
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M556.524 162.631H108.156V427.757H556.524V162.631Z",
    fill: "#1E1E1E",
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M284.655 375.765C284.655 377.799 283.006 379.448 280.972 379.448C278.938 379.448 277.289 377.799 277.289 375.765C277.289 373.731 278.938 372.083 280.972 372.083C283.006 372.084 284.655 373.731 284.655 375.765Z",
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M348.721 371.086H294.597V377.861H348.721V371.086Z",
    fill: "#212121"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M284.655 403.387C284.655 405.421 283.006 407.07 280.972 407.07C278.938 407.07 277.289 405.421 277.289 403.387C277.289 401.353 278.938 399.705 280.972 399.705C283.006 399.706 284.655 401.353 284.655 403.387Z",
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M348.721 400H294.597V406.775H348.721V400Z",
    fill: "#212121"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M239.5 260.987H130.56V343.882H239.5V260.987Z",
    fill: "#2F2F2F"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1_1785",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 130,
    y: 260,
    width: 110,
    height: 84
  }, _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M239.5 260.987H130.56V343.882H239.5V260.987Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1_1785)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M97.9355 336.879C108.537 326.603 119.378 316.155 132.649 309.686C145.921 303.216 162.273 301.274 175.266 308.288C189.403 315.921 196.511 332.036 201.292 347.374C202.97 352.76 197.098 355.699 192.719 359.254C188.34 362.809 183.072 365.084 177.774 367.019C166.006 371.318 153.497 374.18 141.002 373.278C128.507 372.376 115.984 367.393 107.691 358.002",
    fill: "var(--color-primary)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.9355 336.879C108.537 326.603 119.378 316.155 132.649 309.686C145.921 303.216 162.273 301.274 175.266 308.288C189.403 315.921 196.511 332.036 201.292 347.374C202.97 352.76 197.098 355.699 192.719 359.254C188.34 362.809 183.072 365.084 177.774 367.019C166.006 371.318 153.497 374.18 141.002 373.278C128.507 372.376 115.984 367.393 107.691 358.002",
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_1_1785",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 130,
    y: 260,
    width: 110,
    height: 84
  }, _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M239.5 260.987H130.56V343.882H239.5V260.987Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_1_1785)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M256.646 348.757C254.632 344.376 252.618 339.994 250.604 335.613C245.137 323.719 238.545 310.737 226.298 306.115C218.981 303.354 210.683 304.158 203.349 306.873C196.015 309.589 189.488 314.085 183.212 318.752C165.946 331.593 149.913 346.09 135.404 361.979",
    fill: "var(--color-ternary)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.646 348.757C254.632 344.376 252.618 339.994 250.604 335.613C245.137 323.719 238.545 310.737 226.298 306.115C218.981 303.354 210.683 304.158 203.349 306.873C196.015 309.589 189.488 314.085 183.212 318.752C165.946 331.593 149.913 346.09 135.404 361.979",
    stroke: "#212121",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }))), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M206.654 287.483C206.654 291.352 203.517 294.49 199.647 294.49C195.777 294.49 192.64 291.352 192.64 287.483C192.64 283.613 195.777 280.476 199.647 280.476C203.517 280.476 206.654 283.613 206.654 287.483Z",
    fill: "var(--color-primary)",
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M239.5 260.987H130.56V343.882H239.5V260.987Z",
    stroke: "#212121",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M249.701 253.225H120.358V351.645H249.701V253.225Z",
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeDasharray: "4 4"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M542.449 176.355H120.358V232.244H542.449V176.355Z",
    fill: "#1E1E1E",
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeDasharray: "4 4"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M537.042 180.783H125.765V227.815H537.042V180.783Z",
    fill: "#212121"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M168.708 393.1C170.678 380.967 162.438 369.535 150.305 367.566C138.171 365.596 126.739 373.836 124.77 385.969C122.801 398.103 131.041 409.535 143.174 411.504C155.307 413.473 166.739 405.233 168.708 393.1Z",
    fill: "#212121"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M187.978 375.765C187.978 377.799 186.329 379.448 184.295 379.448C182.261 379.448 180.612 377.799 180.612 375.765C180.612 373.731 182.261 372.083 184.295 372.083C186.329 372.083 187.978 373.731 187.978 375.765Z",
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M252.044 371.086H197.92V377.861H252.044V371.086Z",
    fill: "#212121"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M187.978 403.387C187.978 405.421 186.329 407.07 184.295 407.07C182.261 407.07 180.612 405.421 180.612 403.387C180.612 401.353 182.261 399.705 184.295 399.705C186.329 399.705 187.978 401.353 187.978 403.387Z",
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M252.044 400H197.92V406.775H252.044V400Z",
    fill: "#212121"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.55,
    d: "M533.491 259.771H359.639V272.137H533.491V259.771Z",
    fill: "#212121"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.55,
    d: "M533.491 284.127H359.639V296.493H533.491V284.127Z",
    fill: "#212121"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.55,
    d: "M533.491 308.484H359.639V320.849H533.491V308.484Z",
    fill: "#212121"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.55,
    d: "M533.491 332.839H359.639V345.204H533.491V332.839Z",
    fill: "#212121"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M163.737 393.567C165.956 384.17 160.137 374.753 150.74 372.534C141.343 370.315 131.926 376.135 129.707 385.532C127.488 394.929 133.307 404.345 142.704 406.564C152.101 408.783 161.518 402.964 163.737 393.567Z",
    stroke: "#212121",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeDasharray: "4 4"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M462.491 456.806V543.862",
    stroke: "black",
    strokeWidth: 4,
    strokeMiterlimit: 10
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M499.21 543H427.218",
    stroke: "black",
    strokeWidth: 5,
    strokeMiterlimit: 10
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M523.39 411.78C518.474 426.521 510.985 439.971 498.905 450.001C493.686 454.334 489.28 456.552 482.852 458.285C475.085 460.378 467.011 460.871 459.005 461.136C447.326 461.523 435.633 461.492 423.957 461.045C416.722 460.768 408.473 459.793 404.304 453.873C397.051 443.572 404.41 430.848 414.629 427.14C424.461 423.571 434.909 421.885 444.207 416.872C463.676 406.373 468.791 382.668 473.892 363.025C477.604 348.735 479.975 333.024 490.271 321.603C503.222 307.238 523.677 310.061 532.275 327.366C538.449 339.795 533.961 355.113 532.631 368.173C531.137 382.851 528.067 397.755 523.39 411.78Z",
    fill: "var(--color-primary)",
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M341.831 491.789C338.181 492.863 332.162 491.556 330.204 489.104C327.955 486.285 330.689 481.614 331.946 478.895C336.243 469.603 339.689 459.954 343.758 450.564C345.783 445.891 347.964 441.279 350.486 436.851C352.701 432.962 354.87 430.028 359.759 429.425C362.683 429.066 365.644 430.234 367.96 432.055C371.029 434.469 373.148 438.06 373.775 441.915C374.956 449.174 371.025 456.215 366.905 462.308C363.149 467.865 359.109 473.23 354.806 478.375C352.701 480.893 350.533 483.359 348.305 485.77C346.546 487.673 344.374 491.04 341.831 491.789Z",
    fill: "#EBEBEB",
    stroke: "#212121",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M337.91 485.502C334.929 484.15 332.629 482.066 331.066 479.445C329.878 479.819 328.456 480.432 327.608 480.5C325.488 480.671 323.32 480.419 321.215 480.176C315.359 479.502 305.643 474.392 300.724 479.702C299.72 480.785 299.192 482.439 299.816 483.777C300.363 484.952 301.613 485.603 302.782 486.164C313.418 491.264 324.337 495.741 335.25 500.216C338.407 501.51 340.93 501.684 341.976 498.293C343.113 494.607 345.297 491.103 347.034 487.644C343.889 487.417 340.77 486.799 337.91 485.502Z",
    fill: "black"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M479.08 395.165C470.024 402.652 458.705 393.444 448.073 391.676C423.45 387.577 386.534 368.719 369.256 396.008C359.821 410.909 350.332 425.917 343.814 442.305C341.634 447.788 339.699 453.551 336.873 458.684C337.601 459.118 338.321 459.559 339.027 460.005C346.579 464.784 353.486 470.712 361.735 474.3C365.854 476.092 370.09 477.46 374.402 478.5C375.816 476.258 377.151 473.961 378.415 471.619C386.628 456.394 392.037 439.312 399.733 423.83C409.207 404.769 429.391 432.678 434.898 440.329C444.45 448.602 507.447 463.499 479.08 395.165Z",
    fill: "var(--color-ternary)",
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M401.059 543.08C401.041 543.101 401.024 543.122 401.005 543.142C399.941 544.362 398.543 545.24 397.116 546.006C394.139 547.606 390.444 548.843 387.157 547.446C382.22 545.346 384.879 539.599 385.33 535.527C385.968 529.762 386.388 523.968 387.33 518.24C388.678 510.032 391.205 501.779 396.433 495.312C397.94 493.448 399.697 491.724 401.85 490.669C404.131 489.55 406.997 488.992 408.781 490.977C410.663 493.073 411.98 496.42 412.469 499.152C413.032 502.297 412.684 505.53 412.197 508.688C411.214 515.065 409.67 521.355 407.589 527.462C406.628 530.285 405.433 533.011 404.535 535.846C403.735 538.374 402.807 541.034 401.059 543.08Z",
    fill: "#EBEBEB",
    stroke: "#212121",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M450.237 444.604C446.939 440.356 444.281 435.406 440.668 431.513C437.891 428.522 435.197 425.469 432.299 422.593C426.612 416.95 420.057 410.789 412.331 408.121C398.853 403.466 390.978 415.16 388.594 426.628C385.183 443.03 381.773 459.432 378.361 475.836C375.471 489.74 373.33 503.837 370.85 517.824C370.84 517.879 370.83 517.934 370.82 517.989C372.206 518.538 373.641 518.961 375.075 519.363C378.493 520.32 381.96 521.117 385.434 521.843C387.868 522.351 390.318 522.876 392.793 523.135C396.025 523.472 414.864 524.724 415.501 520.964C418.907 500.806 420.122 480.25 422.786 459.967C423.217 456.689 423.695 453.282 425.524 450.528C429.805 444.084 442.879 445.475 449.316 446.27",
    fill: "var(--color-ternary)"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M450.237 444.604C446.939 440.356 444.281 435.406 440.668 431.513C437.891 428.522 435.197 425.469 432.299 422.593C426.612 416.95 420.057 410.789 412.331 408.121C398.853 403.466 390.978 415.16 388.594 426.628C385.183 443.03 381.773 459.432 378.361 475.836C375.471 489.74 373.33 503.837 370.85 517.824C370.84 517.879 370.83 517.934 370.82 517.989C372.206 518.538 373.641 518.961 375.075 519.363C378.493 520.32 381.96 521.117 385.434 521.843C387.868 522.351 390.318 522.876 392.793 523.135C396.025 523.472 414.864 524.724 415.501 520.964C418.907 500.806 420.122 480.25 422.786 459.967C423.217 456.689 423.695 453.282 425.524 450.528C429.805 444.084 442.879 445.475 449.316 446.27",
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M360.089 554.58C360.701 553.612 361.526 552.74 362.414 552.069C364.836 550.239 367.728 549.162 370.554 548.054C375.823 545.988 381.416 543.37 384.003 538.336C389.544 541.442 399.783 540.237 404.943 536.904C404.285 541.985 404.392 547.266 404.052 552.39C404.035 552.646 404.012 552.919 403.855 553.122C403.691 553.333 403.419 553.422 403.163 553.5C398.089 555.047 393.014 556.594 387.939 558.142C383.371 559.535 379.036 561.171 374.255 561.814C371.056 562.244 367.766 562.897 364.532 562.512C362.562 562.277 360.464 561.49 359.523 559.744C358.636 558.097 359.062 556.206 360.089 554.58Z",
    fill: "black"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M328.213 285.107C330.729 290.568 332.324 296.716 334.311 302.403C337.002 310.107 339.747 317.914 344.372 324.637C350.47 333.499 359.475 338.72 370.143 339.409C384.205 340.316 401.323 342.519 413.543 334.216C416.259 332.371 418.758 330.003 419.982 326.957C421.207 323.911 420.906 320.097 418.608 317.753C416.765 315.872 414.03 315.22 411.433 314.781C399.009 312.681 386.398 312.626 373.78 312.105C370.296 311.961 366.749 311.804 363.47 310.618C356.441 308.073 351.933 301.364 347.914 295.06C346.096 292.208 344.279 289.356 342.461 286.503C339.975 282.603 337.391 278.599 333.595 275.955C329.8 273.312 324.445 272.347 320.568 274.87C319.329 275.677 318.261 276.875 317.979 278.327C317.537 280.601 319.17 282.869 321.232 283.925C323.167 284.917 326.018 285.683 328.066 284.793C328.117 284.896 328.165 285.002 328.213 285.107Z",
    fill: "#EBEBEB",
    stroke: "#212121",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M509.176 383.484C514.142 396.724 505.087 406.229 491.498 401.801C467.942 393.259 455.559 303.998 494.182 340.788C500.509 353.884 504.61 369.197 509.176 383.484Z",
    fill: "#EBEBEB",
    stroke: "#212121",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M499.765 347.121C497.934 342.782 495.733 338.603 493.19 334.638C488.104 326.712 481.671 319.646 474.228 313.876C469.59 310.281 463.784 308.945 458.061 308.115C452.052 307.246 446.036 306.375 439.979 305.904C421.712 304.484 403.427 307.174 385.255 309.468C385.286 321.447 385.316 333.427 385.347 345.406C385.352 344.882 399.43 344.311 400.931 344.084C401.44 349.867 402.324 355.37 402.324 361.126C402.324 367.37 403.023 373.722 404.157 379.856C405.312 386.106 406.04 393.184 409.186 398.843C415.75 410.652 433.231 407.873 444.362 406.955C450.86 406.418 457.31 405.749 463.834 405.521C468.146 405.371 472.618 405.577 476.889 404.87C479.079 404.507 481.128 403.788 481.802 401.477C482.713 398.349 481.487 394.373 480.846 391.318C479.392 384.389 478.451 376.185 475.695 369.412C475.309 368.461 474.887 367.539 474.422 366.653C479.124 364.16 483.406 361.28 487.871 358.365C490.201 356.844 492.509 355.286 494.736 353.614C495.844 352.783 496.991 352.006 498.087 351.158C499.892 349.762 500.722 349.388 499.765 347.121Z",
    fill: "var(--color-primary)",
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M426.414 297.309C427.622 299.069 427.219 302.205 426.331 303.991C426.045 304.566 425.598 305.124 425.068 305.471C426.768 307.228 428.682 308.77 430.903 309.831C433.658 311.148 436.83 311.7 439.872 311.525C444.267 311.273 448.71 309.641 452.151 306.833C450.055 306.423 448.296 304.753 447.421 302.777C446.462 300.612 446.401 298.154 446.63 295.796C447.636 285.396 452.327 272.312 442.736 264.441C440.618 262.703 438.325 261.087 435.806 259.985C433.133 258.815 431.332 258.554 428.562 259.31C426.024 260.005 424.054 259.609 421.751 261.205C417.848 263.911 416.491 268.118 416.271 272.669C415.995 278.388 415.94 285.076 418.417 290.37C419.209 292.063 420.399 293.623 422.024 294.548C423.461 295.367 425.433 295.88 426.414 297.309Z",
    fill: "#EBEBEB",
    stroke: "#212121",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M421.113 268.413C422.087 267.844 423.054 267.262 424.127 266.938C425.107 266.641 427.037 266.547 427.798 267.423C428.417 268.135 428.026 268.69 427.965 269.512C427.786 271.964 429.228 273.18 431.705 272.115C432.934 271.587 434.375 270.877 435.512 271.583C437.18 272.618 436.047 274.347 436.273 275.778C436.587 277.753 437.695 280.15 438.693 281.872C440.081 284.266 441.665 287.05 443.884 288.788C450.773 294.177 451.166 282.043 453.221 278.789C453.809 277.86 454.515 276.969 454.79 275.904C455.416 273.477 453.69 271.274 451.969 269.315C451.693 269 451.417 268.693 451.152 268.392C450.908 268.115 450.66 267.817 450.589 267.454C450.396 266.476 452.285 264.71 452.538 263.51C452.979 261.419 451.981 258.847 450.646 257.275C448.799 255.101 445.761 254.007 442.952 254.506C441.726 254.723 440.367 255.195 439.317 254.526C437.786 253.552 438.422 251.602 437.195 250.351C436.105 249.24 434.277 248.739 432.844 249.458C432.181 249.79 431.623 250.316 430.932 250.583C429.381 251.182 427.685 250.344 426.03 250.176C424.226 249.991 422.352 250.668 421.082 251.962C420.11 252.953 419.463 254.289 418.281 255.016C417.006 255.8 415.397 255.706 413.947 256.079C410.197 257.043 407.899 261.614 409.23 265.25C410.561 268.887 415.109 270.908 418.752 269.594C419.58 269.297 420.349 268.859 421.113 268.413Z",
    fill: "black"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M434.242 278.444C434.693 277.621 435.208 276.814 435.92 276.204C438.501 273.998 442.704 275.553 444.138 278.325C444.82 279.643 445.044 281.234 444.647 282.784C444.225 284.429 442.973 285.876 441.35 286.37",
    fill: "#EBEBEB"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M434.242 278.444C434.693 277.621 435.208 276.814 435.92 276.204C438.501 273.998 442.704 275.553 444.138 278.325C444.82 279.643 445.044 281.234 444.647 282.784C444.225 284.429 442.973 285.876 441.35 286.37",
    stroke: "#212121",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M474.28 366.236C471.715 361.157 469.484 357.829 467.048 352.624",
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M421.441 287.728C423.199 287.859 424.996 287.377 426.454 286.385",
    stroke: "black",
    strokeMiterlimit: 10
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_1_1785",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 416,
    y: 258,
    width: 35,
    height: 51
  }, _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M442.735 264.441C457.632 276.668 438.402 298.838 450.975 308.062C442.614 309.578 433.839 308.744 425.914 305.68C426.252 305.811 426.992 300.477 427.021 300.119C427.323 296.392 424.644 296.041 422.025 294.55C420.4 293.625 419.21 292.065 418.417 290.371C415.94 285.077 415.995 278.389 416.271 272.67C416.491 268.118 417.848 263.91 421.751 261.206C424.054 259.609 426.024 260.005 428.562 259.311C431.332 258.555 433.132 258.816 435.806 259.986C438.324 261.087 440.617 262.703 442.735 264.441Z",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_1_1785)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M424.84 296.543C424.827 296.453 424.822 296.354 424.806 296.266C427.476 296.432 430.383 296.265 432.773 295.284C431.458 297.063 427.938 299.497 425.267 301.29C425.33 300.704 425.564 298.092 424.84 296.543Z",
    fill: "black"
  }))), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M442.825 280.744C442.179 278.762 439.964 277.429 437.91 277.789C437.063 277.938 436.201 278.41 435.899 279.215",
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M439.035 277.894C440.263 278.679 440.661 280.516 439.869 281.739",
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M531.252 392.749C481.979 364.194 416.337 415.441 442.663 463.306",
    stroke: "black",
    strokeWidth: 3,
    strokeMiterlimit: 10
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M530.017 407.301L533.973 557.922",
    stroke: "black",
    strokeMiterlimit: 10
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M337.795 407.301L333.84 557.922",
    stroke: "black",
    strokeMiterlimit: 10
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M253.997 351.555L322.264 353.918L325.669 255.558L257.402 253.195L253.997 351.555Z",
    fill: "#212121",
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeDasharray: "4 4"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M257.236 347.22L319.334 349.37L322.432 259.897L260.333 257.747L257.236 347.22Z",
    fill: "#3F3F3F"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M325.671 255.556L253.999 351.553",
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeDasharray: "4 4"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M257.605 253.063L322.065 354.046",
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeDasharray: "4 4"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M538.866 401.965H325.681V409.042H538.866V401.965Z",
    fill: "#EBEBEB",
    stroke: "#212121",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M358.825 402.084H449.552C450.744 402.084 451.712 401.117 451.712 399.923C451.712 398.73 450.745 397.763 449.552 397.763H358.825C357.633 397.763 356.665 398.73 356.665 399.923C356.665 401.116 357.633 402.084 358.825 402.084Z",
    fill: "black"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M356.369 402.084H437.592L430.524 355.412C430.279 353.791 428.903 352.583 427.306 352.583H352.521C350.591 352.583 349.137 354.323 349.433 356.281L356.369 402.084Z",
    fill: "black"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M389.571 377.889C391.719 377.889 393.46 376.148 393.46 374.001C393.46 371.853 391.719 370.112 389.571 370.112C387.424 370.112 385.683 371.853 385.683 374.001C385.683 376.148 387.424 377.889 389.571 377.889Z",
    fill: "#212121",
    stroke: "#EBEBEB",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M328.265 284.861C325.171 285.132 322.041 285.4 318.972 284.925C318.353 284.829 317.709 284.688 317.236 284.278C316.763 283.868 316.538 283.105 316.908 282.6C317.32 282.036 318.156 282.082 318.854 282.127C321.535 282.3 324.267 281.561 326.495 280.061",
    fill: "#EBEBEB"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M328.265 284.861C325.171 285.132 322.041 285.4 318.972 284.925C318.353 284.829 317.709 284.688 317.236 284.278C316.763 283.868 316.538 283.105 316.908 282.6C317.32 282.036 318.156 282.082 318.854 282.127C321.535 282.3 324.267 281.561 326.495 280.061",
    stroke: "#212121",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M488.352 375.015C481.107 372.363 473.826 369.817 466.545 367.265C462.466 365.835 458.453 364.223 454.352 362.855C450.45 361.553 446.358 360.043 442.262 361.344C441.542 361.573 440.813 361.894 440.35 362.491C438.898 364.362 441.257 364.829 442.604 365.034C441.583 364.95 440.696 366.081 440.938 367.078C441.179 368.073 442.373 368.682 443.353 368.384C442.765 368.792 442.111 369.337 442.171 370.05C442.251 370.985 443.428 371.322 444.36 371.425C443.299 371.568 442.934 372.817 443.518 373.587C444.117 374.377 445.198 374.592 446.127 374.702C449.244 375.068 452.39 375.183 455.527 375.046C455.696 375.038 455.872 375.032 456.031 375.089C456.178 375.142 456.299 375.244 456.418 375.345C458.88 377.44 461.418 379.444 464.026 381.354C466.474 383.149 468.578 385.715 470.788 387.821C474.453 391.315 478.074 395.062 482.012 398.206C482.544 398.631 483.076 399.056 483.616 399.468C488.052 402.854 493.643 405.481 499.248 405.97C504.758 406.451 511.41 403.616 512.379 397.521C512.655 395.783 512.405 394.007 512.067 392.28C511.629 390.048 511.042 387.846 510.313 385.691C510.074 384.986 509.813 384.272 509.358 383.682C508.552 382.635 507.255 382.113 506.021 381.64",
    fill: "#EBEBEB"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M488.352 375.015C481.107 372.363 473.826 369.817 466.545 367.265C462.466 365.835 458.453 364.223 454.352 362.855C450.45 361.553 446.358 360.043 442.262 361.344C441.542 361.573 440.813 361.894 440.35 362.491C438.898 364.362 441.257 364.829 442.604 365.034C441.583 364.95 440.696 366.081 440.938 367.078C441.179 368.073 442.373 368.682 443.353 368.384C442.765 368.792 442.111 369.337 442.171 370.05C442.251 370.985 443.428 371.322 444.36 371.425C443.299 371.568 442.934 372.817 443.518 373.587C444.117 374.377 445.198 374.592 446.127 374.702C449.244 375.068 452.39 375.183 455.527 375.046C455.696 375.038 455.872 375.032 456.031 375.089C456.178 375.142 456.299 375.244 456.418 375.345C458.88 377.44 461.418 379.444 464.026 381.354C466.474 383.149 468.578 385.715 470.788 387.821C474.453 391.315 478.074 395.062 482.012 398.206C482.544 398.631 483.076 399.056 483.616 399.468C488.052 402.854 493.643 405.481 499.248 405.97C504.758 406.451 511.41 403.616 512.379 397.521C512.655 395.783 512.405 394.007 512.067 392.28C511.629 390.048 511.042 387.846 510.313 385.691C510.074 384.986 509.813 384.272 509.358 383.682C508.552 382.635 507.255 382.113 506.021 381.64",
    stroke: "#212121",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M313.52 480.857C313.727 479.892 315.475 476.042 316.967 477.339C317.874 478.128 316.645 479.652 316.371 480.457C316.146 481.119 316.265 482.008 316.906 482.286C317.529 482.557 318.236 482.085 318.622 481.526C319.091 480.849 319.313 480.035 319.672 479.295C320.03 478.554 320.602 477.833 321.408 477.661C321.598 477.62 321.806 477.614 321.976 477.708C322.166 477.812 322.273 478.021 322.331 478.229C322.516 478.916 322.247 479.632 322.075 480.323C321.904 481.013 321.867 481.845 322.388 482.331C322.988 482.892 324.031 482.638 324.575 482.022C325.118 481.406 325.294 480.557 325.449 479.751",
    stroke: "var(--color-primary)",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M379.976 545.208C379.674 544.029 378.945 542.963 377.955 542.254C377.359 541.826 376.503 541.54 375.921 541.986C375.459 542.341 375.38 543.027 375.545 543.586C375.71 544.145 376.067 544.623 376.353 545.13C376.731 545.801 376.995 546.606 376.75 547.337C376.504 548.067 375.569 548.578 374.924 548.16C374.615 547.959 374.443 547.611 374.28 547.281C373.98 546.671 373.649 546.05 373.116 545.628C372.584 545.207 371.794 545.036 371.219 545.397C370.498 545.852 370.427 546.875 370.578 547.713C370.727 548.551 371.015 549.427 370.732 550.229C370.052 550.586 369.182 550.356 368.584 549.872C367.987 549.389 367.602 548.697 367.231 548.024",
    stroke: "var(--color-primary)",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M189.677 461.45C188.402 461.844 187.186 462.357 186.04 462.979C186.121 463.066 186.209 463.143 186.284 463.239C187.422 464.73 187.156 466.875 185.688 468.032C184.219 469.188 182.106 468.918 180.968 467.427C180.887 467.323 180.83 467.207 180.763 467.096C179.861 468.075 179.054 469.14 178.354 470.276C178.475 470.311 178.596 470.336 178.715 470.384C180.435 471.097 181.261 473.09 180.558 474.837C179.857 476.584 177.893 477.422 176.173 476.709C176.038 476.654 175.919 476.577 175.795 476.505C175.494 477.805 175.315 479.145 175.27 480.513C175.405 480.476 175.537 480.432 175.679 480.413C177.52 480.156 179.216 481.464 179.468 483.332C179.72 485.201 178.433 486.924 176.592 487.18C176.43 487.202 176.272 487.199 176.113 487.197C176.503 488.522 177.017 489.785 177.641 490.973C177.751 490.857 177.859 490.739 177.988 490.638C179.456 489.482 181.569 489.753 182.708 491.243C183.846 492.734 183.58 494.88 182.112 496.036C181.972 496.146 181.822 496.231 181.672 496.315C182.657 497.256 183.731 498.096 184.879 498.822C184.919 498.655 184.958 498.487 185.024 498.323C185.726 496.576 187.69 495.738 189.41 496.451C191.13 497.163 191.955 499.157 191.254 500.903C191.183 501.079 191.091 501.241 190.995 501.397C192.302 501.708 193.651 501.89 195.027 501.93C194.976 501.759 194.927 501.587 194.901 501.404C194.649 499.535 195.936 497.812 197.778 497.556C199.619 497.3 201.315 498.608 201.567 500.477C201.593 500.667 201.593 500.855 201.587 501.041C202.905 500.635 204.16 500.098 205.34 499.45C205.213 499.328 205.085 499.205 204.974 499.059C203.834 497.568 204.102 495.423 205.57 494.267C207.039 493.111 209.152 493.382 210.29 494.872C210.402 495.018 210.489 495.175 210.574 495.332C211.494 494.325 212.314 493.229 213.022 492.058C212.861 492.019 212.7 491.98 212.542 491.915C210.822 491.203 209.997 489.209 210.698 487.463C211.4 485.716 213.364 484.878 215.084 485.59C215.241 485.655 215.382 485.742 215.523 485.827C215.818 484.513 215.986 483.159 216.02 481.778C215.875 481.818 215.732 481.865 215.578 481.886C213.738 482.142 212.04 480.834 211.788 478.965C211.537 477.096 212.824 475.374 214.665 475.117C214.815 475.096 214.962 475.102 215.109 475.101C214.711 473.793 214.192 472.547 213.565 471.373C213.469 471.47 213.379 471.572 213.27 471.658C211.803 472.814 209.689 472.543 208.55 471.053C207.412 469.562 207.678 467.417 209.146 466.26C209.254 466.175 209.372 466.114 209.486 466.044C208.516 465.135 207.462 464.321 206.338 463.618C206.305 463.737 206.282 463.857 206.235 463.974C205.533 465.721 203.569 466.559 201.849 465.846C200.128 465.134 199.303 463.14 200.005 461.394C200.054 461.274 200.121 461.169 200.18 461.058C198.914 460.764 197.607 460.593 196.276 460.553C196.303 460.667 196.34 460.774 196.357 460.892C196.608 462.761 195.321 464.484 193.48 464.74C191.64 464.996 189.942 463.688 189.691 461.819C189.673 461.696 189.681 461.574 189.677 461.45ZM193.769 467.456C201.271 466.412 208.186 471.739 209.213 479.356C210.242 486.971 204.994 493.991 197.492 495.035C189.99 496.079 183.076 490.75 182.048 483.135C181.02 475.52 186.267 468.5 193.769 467.456Z",
    fill: "var(--color-ternary)"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M194 469.165C200.572 468.251 206.629 472.918 207.53 479.59C208.431 486.261 203.833 492.411 197.262 493.325C190.69 494.24 184.633 489.572 183.732 482.901C182.832 476.229 187.429 470.08 194 469.165Z",
    stroke: "#2D2D2D",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M136.883 448.263C134.9 448.805 133 449.534 131.204 450.432C131.326 450.57 131.457 450.693 131.567 450.846C133.247 453.2 132.729 456.491 130.412 458.197C128.093 459.903 124.851 459.379 123.17 457.025C123.051 456.859 122.969 456.679 122.872 456.504C121.434 457.966 120.139 459.566 119.003 461.279C119.187 461.339 119.374 461.383 119.555 461.464C122.169 462.65 123.342 465.762 122.175 468.417C121.007 471.072 117.941 472.263 115.326 471.077C115.122 470.985 114.941 470.86 114.755 470.745C114.226 472.732 113.885 474.786 113.747 476.891C113.957 476.841 114.161 476.781 114.381 476.758C117.229 476.457 119.778 478.557 120.075 481.449C120.371 484.341 118.302 486.928 115.454 487.23C115.204 487.256 114.961 487.241 114.717 487.232C115.252 489.292 115.982 491.262 116.883 493.126C117.058 492.954 117.229 492.778 117.433 492.628C119.751 490.922 122.993 491.447 124.674 493.801C126.355 496.155 125.837 499.446 123.519 501.152C123.298 501.315 123.062 501.438 122.828 501.56C124.3 503.059 125.911 504.409 127.644 505.585C127.713 505.329 127.783 505.073 127.893 504.823C129.061 502.169 132.126 500.977 134.741 502.163C137.356 503.348 138.528 506.462 137.361 509.116C137.243 509.385 137.093 509.628 136.939 509.864C138.937 510.41 141.005 510.759 143.123 510.892C143.053 510.625 142.986 510.358 142.957 510.075C142.661 507.184 144.73 504.596 147.578 504.296C150.426 503.996 152.976 506.096 153.272 508.988C153.301 509.282 153.292 509.572 153.274 509.858C155.324 509.299 157.283 508.538 159.134 507.599C158.942 507.405 158.753 507.208 158.589 506.978C156.908 504.624 157.426 501.333 159.744 499.627C162.063 497.92 165.305 498.445 166.985 500.799C167.15 501.03 167.277 501.275 167.4 501.523C168.868 500.019 170.185 498.373 171.333 496.606C171.087 496.537 170.841 496.468 170.602 496.361C167.988 495.175 166.815 492.062 167.982 489.408C169.15 486.753 172.216 485.562 174.831 486.748C175.069 486.856 175.282 486.996 175.496 487.135C176.014 485.127 176.342 483.05 176.462 480.923C176.236 480.979 176.013 481.042 175.776 481.067C172.928 481.368 170.378 479.268 170.082 476.376C169.786 473.484 171.855 470.897 174.703 470.595C174.935 470.571 175.161 470.587 175.387 470.593C174.838 468.558 174.1 466.611 173.193 464.772C173.04 464.916 172.897 465.069 172.724 465.197C170.405 466.903 167.164 466.378 165.483 464.024C163.802 461.67 164.32 458.379 166.638 456.673C166.808 456.547 166.992 456.459 167.171 456.358C165.723 454.907 164.139 453.6 162.441 452.459C162.384 452.64 162.342 452.824 162.264 453.002C161.096 455.656 158.03 456.848 155.416 455.662C152.801 454.476 151.628 451.363 152.795 448.709C152.876 448.527 152.985 448.37 153.081 448.202C151.144 447.685 149.141 447.355 147.093 447.224C147.129 447.399 147.181 447.567 147.2 447.749C147.496 450.641 145.427 453.229 142.579 453.529C139.731 453.829 137.182 451.729 136.886 448.837C136.864 448.642 136.882 448.455 136.883 448.263ZM142.888 457.724C154.495 456.499 164.882 465.059 166.089 476.842C167.296 488.625 158.864 499.171 147.257 500.397C135.65 501.621 125.264 493.062 124.057 481.279C122.85 469.494 131.282 458.949 142.888 457.724Z",
    fill: "url(#paint1_linear_1_1785)"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M141.953 503.224C155.079 504.981 167.165 495.568 168.896 482.242C170.628 468.916 161.358 456.646 148.232 454.888C135.105 453.131 123.018 462.541 121.287 475.868C119.557 489.193 128.826 501.466 141.953 503.224ZM129.1 476.914C130.263 467.961 138.384 461.639 147.202 462.819C156.021 464 162.248 472.244 161.084 481.196C159.921 490.149 151.801 496.472 142.983 495.291C134.165 494.111 127.938 485.866 129.1 476.914Z",
    fill: "url(#paint2_linear_1_1785)"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M126.267 476.534C127.636 465.995 137.195 458.553 147.576 459.943C157.956 461.333 165.287 471.038 163.918 481.577C162.549 492.116 152.991 499.559 142.61 498.17C132.229 496.779 124.897 487.073 126.267 476.534Z",
    stroke: "white",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M319.362 457.491V445.912H241.684V457.491H319.362Z",
    fill: "var(--color-primary)",
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M226.439 451.759L241.811 457.491V445.912L226.439 451.759Z",
    fill: "black",
    stroke: "#212121",
    strokeMiterlimit: 10
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M203.007 451.923L214.886 459.44L228.596 451.85L215.328 443.962L203.007 451.923Z",
    fill: "black"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M214.222 449.711C215.321 449.711 216.212 450.602 216.212 451.701C216.212 452.8 215.321 453.691 214.222 453.691C213.123 453.691 212.232 452.8 212.232 451.701C212.232 450.602 213.123 449.711 214.222 449.711Z",
    fill: "#FADDD4"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M203.007 451.702H214.222",
    stroke: "#FADDD4",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M234.023 451.152V452.094C234.023 455.105 231.583 457.545 228.573 457.545C225.562 457.545 223.122 455.105 223.122 452.094V451.152C223.122 448.142 225.562 445.701 228.573 445.701C231.582 445.701 234.023 448.142 234.023 451.152Z",
    fill: "var(--color-primary)",
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M542.751 156.241C542.368 155.661 541.917 155.121 541.396 154.632C536.982 150.493 529.924 151.669 524.161 153.515C511.267 157.642 496.691 165.023 489.159 176.672C480.875 189.483 476.47 204.736 472.233 219.244C471.648 221.247 469.859 225.343 469.959 228.238C472.021 228.132 474.096 228.063 476.159 228.163C477.453 226.425 478.611 224.416 479.367 223.37C488.192 211.147 499.054 200.261 511.915 192.305C523.321 185.25 536.31 182.132 542.871 169.16C544.906 165.138 545.168 159.897 542.751 156.241Z",
    fill: "var(--color-ternary)",
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M465.395 228.147H467.702C467.698 228.114 467.699 228.08 467.695 228.048C467.595 227.311 467.383 226.601 467.268 225.798C467.065 224.365 466.851 222.955 466.51 221.536C465.766 218.44 464.783 215.411 463.879 212.361C462.433 207.485 460.785 202.633 458.313 198.169C455.795 193.621 452.326 189.468 447.782 186.942C436.87 180.877 417.164 184.388 411.862 196.728C410.113 200.798 410.478 205.959 413.545 209.156C415.017 210.691 416.984 211.68 419.02 212.293C421.78 213.123 424.732 213.307 427.574 212.824C434.506 211.646 442.506 209.564 449.656 211.453C450.377 211.644 451.081 211.892 451.763 212.19C455.445 213.803 458.312 216.803 460.743 219.924C462.725 222.472 464.663 225.039 465.395 228.147Z",
    fill: "var(--color-ternary)",
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M462.625 199.638C463.824 204.244 464.645 208.948 465.365 213.655C465.723 215.99 467.925 224.301 467.769 228.347H468.012C468.554 228.316 469.749 228.25 469.96 228.237C472.003 224.549 471.511 220.363 472.327 216.192C475.494 200 480.971 182.248 477.035 165.822C474.759 156.324 469.644 147.181 461.491 141.805C453.338 136.43 441.912 135.552 433.913 141.154C432.393 142.219 430.99 143.524 430.132 145.169C428.01 149.239 429.691 154.27 432.132 158.157C434.22 161.481 436.848 164.465 439.883 166.956C443.054 169.558 446.654 171.619 449.697 174.371C453.294 177.624 455.93 181.654 457.965 186.012C460 190.375 461.435 195.065 462.625 199.638Z",
    fill: "var(--color-primary)",
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M473.162 227.417C482.964 207.849 492.898 186.236 511.767 173.851C516.941 170.454 522.441 167.591 527.927 164.738",
    stroke: "#212121",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M466.619 227.812C461.734 216.503 457.033 206.985 446.594 202.073C439.839 199.003 432.471 199.617 425.942 200.244",
    stroke: "#212121",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M453.5 159.015C473.613 175.668 468.7 203.915 469.081 227.433",
    stroke: "#212121",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M453.253 228.263H498.122",
    stroke: "#212121",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M135.279 536.792C136.752 538.094 138.634 538.739 140.579 538.612C142.178 538.507 143.807 537.72 145.552 536.207L186.869 533.729L186.181 523.253L144.955 525.726C143.558 524.444 141.68 523.814 139.622 523.951C137.771 524.072 136.124 524.879 134.911 526.109C133.487 527.552 132.661 529.578 132.805 531.761C132.931 533.708 133.811 535.494 135.279 536.792ZM137.844 529.752C138.168 529.274 138.804 528.926 139.365 528.843C139.944 528.757 140.434 528.917 140.92 529.187C140.809 529.125 140.699 529.065 140.588 529.003C140.598 529.006 140.608 529.011 140.617 529.014C141.61 529.372 142.149 530.418 142.082 531.428C142.019 532.376 141.094 533.414 140.118 533.464C140.106 533.465 140.094 533.465 140.082 533.466C139.667 533.487 139.299 533.442 138.944 533.318C138.943 533.323 138.943 533.328 138.942 533.333C138.911 533.322 138.877 533.3 138.845 533.284C138.683 533.219 138.523 533.141 138.364 533.034C138.326 533.008 138.298 532.973 138.263 532.946C137.218 532.253 137.21 530.692 137.844 529.752Z",
    fill: "var(--color-primary)",
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M186.176 526.414L144.407 528.928",
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M186.489 530.522L144.556 533.018",
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M191.113 537.315C195.962 536.998 199.816 533.254 200.276 528.417L200.427 526.829L192.38 530.732L189.268 524.314L197.45 520.348L196.231 519.469C194.379 518.134 192.102 517.48 189.821 517.631C187.39 517.791 185.151 518.817 183.455 520.536C183.316 520.677 183.181 520.821 183.051 520.971C181.314 522.952 180.452 525.49 180.625 528.12C180.982 533.546 185.688 537.671 191.113 537.315Z",
    fill: "var(--color-primary)",
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "M134.819 529.453C135.745 526.745 138.691 525.299 141.399 526.225C144.108 527.152 145.553 530.098 144.627 532.806C143.701 535.514 140.755 536.959 138.047 536.033C135.338 535.107 133.893 532.161 134.819 529.453Z",
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "M242.538 133.057L232.521 145.935",
    stroke: "var(--color-primary)",
    strokeMiterlimit: 10
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "M250.408 133.057L240.391 145.935",
    stroke: "var(--color-primary)",
    strokeMiterlimit: 10
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "M258.277 133.057L248.261 145.935",
    stroke: "var(--color-primary)",
    strokeMiterlimit: 10
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    d: "M324.688 133.057L314.673 145.935",
    stroke: "var(--color-primary)",
    strokeMiterlimit: 10
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    d: "M332.559 133.057L322.542 145.935",
    stroke: "var(--color-primary)",
    strokeMiterlimit: 10
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    d: "M257.554 140.989H264.739",
    stroke: "var(--color-primary)",
    strokeMiterlimit: 10
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    d: "M267.445 140.989H274.632",
    stroke: "var(--color-primary)",
    strokeMiterlimit: 10
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    d: "M277.338 140.989H284.523",
    stroke: "var(--color-primary)",
    strokeMiterlimit: 10
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    d: "M331.088 140.989H338.274",
    stroke: "var(--color-primary)",
    strokeMiterlimit: 10
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    d: "M340.98 140.989H348.166",
    stroke: "var(--color-primary)",
    strokeMiterlimit: 10
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    d: "M305.707 140.989H312.892",
    stroke: "var(--color-primary)",
    strokeMiterlimit: 10
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    d: "M297.4 135.111L289.002 140.758L296.281 147.242",
    stroke: "var(--color-primary)",
    strokeMiterlimit: 10
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    d: "M304.493 135.111L296.094 140.758L303.374 147.242",
    stroke: "var(--color-primary)",
    strokeMiterlimit: 10
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    d: "M157.793 196.868L147.714 204.147L157.233 210.306",
    stroke: "var(--color-primary)",
    strokeMiterlimit: 10
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    d: "M250.737 196.868L240.659 204.147L250.177 210.306",
    stroke: "var(--color-primary)",
    strokeMiterlimit: 10
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    d: "M164.511 201.106H176.829",
    stroke: "var(--color-primary)",
    strokeMiterlimit: 10
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    d: "M164.511 206.067H176.829",
    stroke: "var(--color-primary)",
    strokeMiterlimit: 10
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    d: "M188.027 197.428L183.548 209.746",
    stroke: "var(--color-primary)",
    strokeMiterlimit: 10
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    d: "M194.746 197.428L190.267 209.746",
    stroke: "var(--color-primary)",
    strokeMiterlimit: 10
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    d: "M263.055 197.428L258.576 209.746",
    stroke: "var(--color-primary)",
    strokeMiterlimit: 10
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    d: "M269.774 197.428L265.294 209.746",
    stroke: "var(--color-primary)",
    strokeMiterlimit: 10
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    d: "M203.145 200.787C203.145 201.405 202.644 201.907 202.026 201.907C201.407 201.907 200.906 201.405 200.906 200.787C200.906 200.169 201.407 199.667 202.026 199.667C202.644 199.667 203.145 200.169 203.145 200.787Z",
    stroke: "var(--color-primary)",
    strokeMiterlimit: 10
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    d: "M203.145 206.386C203.145 207.005 202.644 207.506 202.026 207.506C201.407 207.506 200.906 207.005 200.906 206.386C200.906 205.768 201.407 205.267 202.026 205.267C202.644 205.267 203.145 205.768 203.145 206.386Z",
    stroke: "var(--color-primary)",
    strokeMiterlimit: 10
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    d: "M220.503 203.587C220.503 207.607 218.246 210.865 215.463 210.865C212.68 210.865 210.424 207.607 210.424 203.587C210.424 199.566 212.68 196.308 215.463 196.308C218.246 196.308 220.503 199.567 220.503 203.587Z",
    stroke: "var(--color-primary)",
    strokeMiterlimit: 10
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    d: "M236.18 203.587C236.18 207.607 233.924 210.865 231.141 210.865C228.358 210.865 226.102 207.607 226.102 203.587C226.102 199.566 228.358 196.308 231.141 196.308C233.924 196.308 236.18 199.567 236.18 203.587Z",
    stroke: "var(--color-primary)",
    strokeMiterlimit: 10
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    d: "M514.145 244.934L505.256 252.212L513.652 258.372",
    stroke: "var(--color-primary)",
    strokeMiterlimit: 10
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    d: "M527.263 244.934L518.373 252.212L526.769 258.372",
    stroke: "var(--color-primary)",
    strokeMiterlimit: 10
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    d: "M531.707 249.172H542.572",
    stroke: "var(--color-primary)",
    strokeMiterlimit: 10
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    d: "M531.707 254.134H542.572",
    stroke: "var(--color-primary)",
    strokeMiterlimit: 10
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    d: "M464.76 251.652H473.156",
    stroke: "var(--color-primary)",
    strokeMiterlimit: 10
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    d: "M478.094 251.652H486.49",
    stroke: "var(--color-primary)",
    strokeMiterlimit: 10
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    d: "M491.428 251.652H499.823",
    stroke: "var(--color-primary)",
    strokeMiterlimit: 10
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1_1785",
    x1: 635,
    y1: 669.881,
    x2: 677.838,
    y2: 644.856,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "var(--color-second)"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E73636"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1_1785",
    x1: 120.018,
    y1: 498.006,
    x2: 174.159,
    y2: 466.852,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "var(--color-second)"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E73636"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1_1785",
    x1: 120.018,
    y1: 498.006,
    x2: 174.159,
    y2: 466.852,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "var(--color-second)"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E73636"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDevelopment);
export default __webpack_public_path__ + "static/media/DEVELOPMENT.f918bba8223be8ae56a64bf7ef19142b.svg";
export { ForwardRef as ReactComponent };